import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoad = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 22 22",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill-opacity: .9;\n      }\n    " }) }), /* @__PURE__ */ _jsx("g", {
		id: "Layer_1",
		focusable: "false",
		children: /* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M16.5,3.7h1.8v14.7h-1.8V3.7ZM3.7,3.7h1.8v14.7h-1.8V3.7ZM10.1,3.7h1.8v3.7h-1.8v-3.7ZM10.1,9.2h1.8v3.7h-1.8v-3.7ZM10.1,14.7h1.8v3.7h-1.8v-3.7Z"
		})
	})]
});
export default SvgRoad;
